<div [dir]='data.dir' class="dialog-container">
    <h1 mat-dialog-title class="custom-title" *ngIf="data.title">
        <span>{{'forms.common.' + data.title | translate}}
        </span>
    </h1>

    <formio-loader></formio-loader>
    <formio [formKey]="data.formKey" [submission]="data.submission" [readOnly]="false"
        (customEvent)="onCustomEvent($event)" (submit)="onSubmit($event)" (hideFormDialog)="onNoClick()">
    </formio>
</div>